import { ErrorStateMatcher } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    const invalidCtrl = !!(control && control.invalid && (control.touched || control.parent.dirty || isSubmitted));
    const invalidParent = !!(control && control.parent && control.parent.invalid && (control.parent.dirty || control.parent.touched || isSubmitted));
    return (invalidCtrl || invalidParent);
  }
}
